import { render, staticRenderFns } from "./NewsSearch.vue?vue&type=template&id=43fa7c97&scoped=true"
import script from "./NewsSearch.vue?vue&type=script&lang=js"
export * from "./NewsSearch.vue?vue&type=script&lang=js"
import style0 from "./NewsSearch.vue?vue&type=style&index=0&id=43fa7c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fa7c97",
  null
  
)

export default component.exports